export const ProductTypes = {
    custom_product: "products"
}

export const ProductNumeralTypes = {
    custom_product: 0
}
